"use strict";

import { timeStringToDate } from './utils';
import { DiaSemana } from './marcacaoUtils';
import { conection, errorFuncStruct } from './conectionUtils';

export interface ItHorario{
  dia_semana: DiaSemana;
  hora_entrada: string;
  hora_almoco: string;
  hora_tarde: string;
  hora_saida: string;
  hora_transporte: string;
  hora_fim_transporte: string;
  total_slot: number;
  tempo_slot: number;
}
export interface Iterapeuta{
  id: number;
  activo: number;
  flag_fisio: number;
  nome: string;
  nome_pesquisa: string;
  telefone: string | null;
  hora_entrada: string;
  hora_almoco: string;
  hora_tarde: string;
  hora_saida: string;
  hora_transporte: string;
  hora_fim_transporte: string;
  total_slot: number;
  tempo_slot: number;
  horarios: ItHorario[];
}

export function getTerapeutaById(id: number, terapeutas: Terapeuta[]): Terapeuta | null{
  let terapeutaReturn: Terapeuta | null = null;
  for (let index = 0; index < terapeutas.length; index++) {
    const element = terapeutas[index];
    if(element.id == id){
      terapeutaReturn = element;
      index = terapeutas.length;
    }
  }
  return terapeutaReturn;
}

export function getAllTerapeutasServer(
  cbOk: (terapeutas: Iterapeuta[]) => void,
  cbError: errorFuncStruct
){
  conection(
    "getAllTerapeutas.php",
    {},
    (resp: {terapeutas: Iterapeuta[]}) => {
      cbOk(resp.terapeutas);
    },
    cbError
  );
}

export type TerapeutaSteroids = {activo: boolean; dados: Terapeuta; horas: string[]};

export class Terapeuta {
  private formatBD: Iterapeuta;
  constructor(t: Iterapeuta) {
    this.formatBD = t;
  }

  public get id(): number {
    return this.formatBD.id;
  }
  public get nome(): string {
    return this.formatBD.nome;
  }

  public get horaEntrada(): Date {
    return timeStringToDate(this.formatBD.hora_entrada);
  }

  public get horaSaida(): Date{
    return timeStringToDate(this.formatBD.hora_saida);
  }

  public get horaAlmoco(): Date{
    return timeStringToDate(this.formatBD.hora_almoco);
  }

  public get horaTarde(): Date{
    return timeStringToDate(this.formatBD.hora_tarde);
  }

  public get horaTransporte(): Date{
    return timeStringToDate(this.formatBD.hora_transporte);
  }

  public get horaFimTransporte(): Date{
    return timeStringToDate(this.formatBD.hora_fim_transporte);
  }

  public get tempoSlot(): number{
    return this.formatBD.tempo_slot;
  }

  public get totalSlot(): number{
    return this.formatBD.total_slot;
  }

  public get horarios(): ItHorario[]{
    return this.formatBD.horarios;
  }
  
}